import React from "react";
import { array } from "prop-types";

import NewsWithImage from "../../../molecules/NewsWithImage";
import WideStoryCard from "../../../molecules/WideStoryCard";

import { useDevice } from "../../../utils/react-utils";

import "./organism1.m.css";

const Organism1 = ({ storyList = [] }) => {
  if (!storyList.length) return null;

  const { desktop } = useDevice();
  const [firstStory, ...otherStory] = storyList;

  return (
    <div styleName="base">
      <WideStoryCard
        story={firstStory}
        styleName="story"
        cssStyleName="semiBigSize"
        aspectRatio={[3, 2]}
        imageType="image3x2"
        excerptShow={false}
        widths={[400, 560, 700]}
      />
      {otherStory.map((story, index) => (
        <NewsWithImage styleName="story" story={story} key={index} showExcerpt={desktop} widths={[200, 300, 400]} />
      ))}
    </div>
  );
};

Organism1.propTypes = {
  storyList: array.isRequired,
};

export default Organism1;
